import { z } from 'zod';
// What a subscription continues from.
export const subscriptionPredecessorKindSchema = z.enum(['CreditContract', 'LeadOrTimeContract', 'Subscription']);
export const SubscriptionPredecessorKind = subscriptionPredecessorKindSchema.enum;
// At most one predecessor.
export const subscriptionPredecessorSchema = z.object({
    kind: subscriptionPredecessorKindSchema,
    // Absent for a credits migration: that converts every credit contract the partner still holds, so the server
    // derives the one it records rather than the caller naming it. Every other kind has to name its row.
    id: z.number().int().positive().optional(),
});
export const subscriptionPredecessorCandidateSchema = z.object({
    kind: subscriptionPredecessorKindSchema,
    id: z.number().int().positive(),
    label: z.string(),
    // The most recent moment when the entry was active.
    activityAt: z.iso.datetime().nullable(),
});
export const subscriptionPredecessorSummarySchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal(subscriptionPredecessorKindSchema.enum.CreditContract),
        id: z.number().int(),
        title: z.string(),
        startDate: z.iso.datetime(),
    }),
    z.object({
        kind: z.literal(subscriptionPredecessorKindSchema.enum.LeadOrTimeContract),
        id: z.number().int(),
        productType: z.string(),
        productId: z.string(),
    }),
    z.object({
        kind: z.literal(subscriptionPredecessorKindSchema.enum.Subscription),
        id: z.number().int(),
        uuid: z.uuid(),
        planName: z.string(),
        startedAt: z.iso.datetime().nullable(),
    }),
]);
